<!--https://material.angular.io/components/dialog/overview-->
<h1 mat-dialog-title [innerHTML]="data.title"></h1>
<div mat-dialog-content [innerHTML]="data.content"></div>
<div mat-dialog-actions class="dialogSelectContainer">
  <button mat-raised-button [mat-dialog-close]="false" cdkFocusInitial id="cancel">취소</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary" [attr.id]="actionId">{{ actionName }}</button>
</div>
